import TeamHero from './components/TeamHero';
import CoachingStaffSection from './components/CoachingStaffSection';
import RosterSection from './components/RosterSection';
import FooterSection from '@/pages/home/components/FooterSection';

export default function TeamPage() {
  return (
    <main className="w-full">
      <TeamHero />
      <CoachingStaffSection />
      <RosterSection />
      <FooterSection />
    </main>
  );
}
